"use client";
import { useTranslations } from "next-intl";
import Card from "@/ui/elements/card";
import SectionShell from "@/ui/elements/sectionShell";
import Reveal from "@/ui/elements/reveal";

export default function FeatureSection() {
  const t = useTranslations("services");
  const cards = [
    {
      image:
        "https://galeria.tocumenaero.com/gallery/api/Generales/9M1A4049__1_.jpg",
      title: t("lost.title"),
      description: t("lost.description"),
      buttonLabel: t("lost.buttonLabel"),
      buttonLink: "/pasajeros/lost-and-found",
    },
    {
      image:
        "https://galeria.tocumenaero.com/gallery/api/Servicio%20al%20pasajero/321A8818.jpg",
      title: t("guide.title"),
      description: t("guide.description"),
      buttonLabel: t("guide.buttonLabel"),
      buttonLink: "/informacion",
    },
    {
      image: "https://galeria.tocumenaero.com/gallery/transporte/taxi2.JPG",
      title: t("taxi.title"),
      description: t("taxi.description"),
      buttonLabel: t("taxi.buttonLabel"),
      buttonLink: "/transporte/taxi",
    },
  ];

  return (
    <SectionShell
      eyebrow={t("eyebrow")}
      title={t("title")}
      subtitle={t("subtitle")}
      tone="dark"
    >
      <Reveal className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 items-stretch">
        {cards.map((card) => (
          <Card key={card.buttonLink} {...card} />
        ))}
      </Reveal>
    </SectionShell>
  );
}
